/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/*
    I build on the assert library to add a few more assertion types, and export
    the entire assert structure, so I can be required as a direct replacement
    for requiring assert itself.
*/
import assert from "./assert";

assert.lessThan = (assert["<"] = function(actual, expected, message) {
    if (actual >= expected) {
        assert.fail(actual, expected, message, "<", assert.lessThan);
    }
});

assert.lessThanEqual = (assert["<="] = function(actual, expected, message) {
    if (actual > expected) {
        assert.fail(actual, expected, message, "<=", assert.lessThanEqual);
    }
});

assert.greaterThan = (assert[">"] = function(actual, expected, message) {
    if (actual <= expected) {
        assert.fail(actual, expected, message, ">", assert.greaterThan);
    }
});

assert.greaterThanEqual = (assert[">="] = function(actual, expected, message) {
    if (actual < expected) {
        assert.fail(actual, expected, message, ">=", assert.greaterThanEqual);
    }
});

assert["=="] = function(actual, expected, message) {
    if ((typeof expected === "string") || (typeof expected === "number") || (typeof expected === "boolean")) {
        return assert.equal.apply(this, arguments);
    } else {
        return assert.deepEqual.apply(this, arguments);
    }
};

assert["!="] = function(actual, expected, message) {
    if ((typeof expected === "string") || (typeof expected === "number") || (typeof expected === "boolean")) {
        return assert.notEqual.apply(this, arguments);
    } else {
        return assert.notDeepEqual.apply(this, arguments);
    }
};

assert.match = (assert["=~"] = function(actual, regex, message) {
    if (typeof regex === "string") {
        regex = new RegExp(regex);
    }
    if (!regex.test(actual)) {
        assert.fail(actual, regex, message, "=~", assert.match);
    }
});

assert.notMatch = (assert["!~"] = function(actual, regex, message) {
    if (typeof regex === "string") {
        regex = new RegExp(regex);
    }
    if (regex.test(actual)) {
        assert.fail(actual, regex, message, "!~", assert.notMatch);
    }
});

const assert_moar = assert;

export default assert_moar;



// WEBPACK FOOTER //
// ./test/it/lib/assert_moar.js